import * as React from "react";

const COMPARE_KEY = "verhuismatch_compare";
const MAX_COMPARE = 4;

export const useCompare = () => {
  const [compareList, setCompareList] = React.useState<string[]>([]);

  React.useEffect(() => {
    const stored = localStorage.getItem(COMPARE_KEY);
    if (stored) {
      try {
        setCompareList(JSON.parse(stored));
      } catch {
        setCompareList([]);
      }
    }
  }, []);

  const toggleCompare = React.useCallback((companyId: string) => {
    setCompareList((prev) => {
      let newList: string[];
      if (prev.includes(companyId)) {
        newList = prev.filter((id) => id !== companyId);
      } else if (prev.length < MAX_COMPARE) {
        newList = [...prev, companyId];
      } else {
        return prev; // Max reached
      }
      localStorage.setItem(COMPARE_KEY, JSON.stringify(newList));
      return newList;
    });
  }, []);

  const isInCompare = React.useCallback(
    (companyId: string) => compareList.includes(companyId),
    [compareList]
  );

  const clearCompare = React.useCallback(() => {
    setCompareList([]);
    localStorage.removeItem(COMPARE_KEY);
  }, []);

  const canAddMore = compareList.length < MAX_COMPARE;

  return { 
    compareList, 
    toggleCompare, 
    isInCompare, 
    clearCompare, 
    canAddMore,
    maxCompare: MAX_COMPARE 
  };
};
